import { useContext, useState } from "react";
import Configurationcontext from "../../Context/ConfigrationContext/Configurationcontext";
import configurationConstants from "../../apis/configuration/configurationConstants";
import ConfirmationModal from "./ConfirmationModal";

const AuditingConfiguration = ({
  configAuditOptions,
  configFeedbackTypes,
  location,
  clientCurrentId,
  fetchConfigurationData,
  handleApplyDefaultCategories
}) => {
  const data = useContext(Configurationcontext);
  const configurationProvider = useContext(Configurationcontext);
  const auditOptions = "audit_options";
  const feedbackTypes = "feedback_types";
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [deleteParams, setDeleteParams] = useState({});

  return (
    <>
      <div className="d-flex flex-column gap-7 gap-lg-5">
        <div className="col-12 d-flex justify-content-end align-items-center mb-4">
          <div className="d-flex flex-col gap-2 " >
            <button
                type="button"
                className="btn btn-light-primary"
                onClick={()=>handleApplyDefaultCategories("AUDITING_CONFIGURATION")}
              >
                Apply Default Categories
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="card card-flush mb-4">
              <div className="card-header">
                <div className="card-title">
                  <h4>Audit Options</h4>
                </div>
              </div>
              <div className="card-body pt-0">
                <div
                  className=""
                  data-kt-ecommerce-catalog-add-product="auto-options"
                >
                  <div id="kt_ecommerce_add_product_options">
                    <div className="form-group">
                      <div
                        data-repeater-list="kt_ecommerce_add_product_options"
                        className="d-flex flex-column gap-3"
                      >
                        {location?.length !== 0
                          ? data.configAuditOptions.map((item, i) => (
                              <div
                                data-repeater-item=""
                                className="form-group d-flex flex-wrap align-items-center gap-5"
                                key={i}
                              >
                                <input
                                  type="text"
                                  className="form-control mw-100 w-85"
                                  name="product_option_value"
                                  value={
                                    (configurationProvider.editedData[
                                      configurationConstants
                                        .AUDITING_CONFIGURATION
                                    ][configurationConstants.AUDIT_OPTIONS] ??
                                      {})[item.id] ?? item.audit_opt
                                  }
                                  placeholder={item.audit_opt}
                                  onChange={(e) =>
                                    configurationProvider.onEditFieldChange(
                                      configurationConstants.AUDITING_CONFIGURATION,
                                      configurationConstants.AUDIT_OPTIONS,
                                      item.id,
                                      e.target.value,
                                    )
                                  }
                                />
                                <button
                                  type="button"
                                  data-repeater-delete=""
                                  className="btn btn-sm btn-icon btn-light-danger"
                                  onClick={() => {
                                    setDeleteParams({
                                      config_option: item?.audit_opt,
                                      id: item?.id,
                                      LocationId: item?.LocationId,
                                      clientCurrentId,
                                      type: auditOptions,
                                    });
                                    setShowConfirmationModal(true);
                                  }}
                                >
                                  <span className="svg-icon svg-icon-1">
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect
                                        opacity="0.5"
                                        x="7.05025"
                                        y="15.5356"
                                        width="12"
                                        height="2"
                                        rx="1"
                                        transform="rotate(-45 7.05025 15.5356)"
                                        fill="currentColor"
                                      />
                                      <rect
                                        x="8.46447"
                                        y="7.05029"
                                        width="12"
                                        height="2"
                                        rx="1"
                                        transform="rotate(45 8.46447 7.05029)"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                </button>
                              </div>
                            ))
                          : ""}
                      </div>
                      <div className="form-group mt-5">
                        <div className="form-group">
                          <div
                            data-repeater-list="kt_ecommerce_add_product_options"
                            className="d-flex flex-column gap-3"
                          >
                            {(
                              configurationProvider.submitData[
                                configurationConstants.AUDITING_CONFIGURATION
                              ].auditorOption ?? []
                            ).map((e, i) => {
                              return (
                                <div id="kt_ecommerce_add_product_options">
                                  <div id="process">
                                    <div className="applicant-fields">
                                      <div className="form-group">
                                        <div
                                          data-repeater-list="kt_ecommerce_add_product_options"
                                          className="d-flex flex-column gap-3"
                                        >
                                          <div
                                            data-repeater-item=""
                                            className="form-group d-flex flex-wrap align-items-center gap-5"
                                          >
                                            <input
                                              type="text"
                                              className="form-control mw-100 w-85"
                                              onChange={(e) =>
                                                configurationProvider.onFieldChange(
                                                  configurationConstants.AUDITING_CONFIGURATION,
                                                  configurationConstants.AUDIT_OPTIONS,
                                                  i,
                                                  e.target.value,
                                                )
                                              }
                                            />
                                            <button
                                              type="button"
                                              data-repeater-delete=""
                                              className="btn btn-sm btn-icon btn-light-danger"
                                              onClick={() =>
                                                configurationProvider.onDeleteClick(
                                                  configurationConstants.AUDITING_CONFIGURATION,
                                                  configurationConstants.AUDIT_OPTIONS,
                                                  i,
                                                )
                                              }
                                            >
                                              <span className="svg-icon svg-icon-1">
                                                <svg
                                                  width="24"
                                                  height="24"
                                                  viewBox="0 0 24 24"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <rect
                                                    opacity="0.5"
                                                    x="7.05025"
                                                    y="15.5356"
                                                    width="12"
                                                    height="2"
                                                    rx="1"
                                                    transform="rotate(-45 7.05025 15.5356)"
                                                    fill="currentColor"
                                                  />
                                                  <rect
                                                    x="8.46447"
                                                    y="7.05029"
                                                    width="12"
                                                    height="2"
                                                    rx="1"
                                                    transform="rotate(45 8.46447 7.05029)"
                                                    fill="currentColor"
                                                  />
                                                </svg>
                                              </span>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group mt-5">
                      <button
                        type="button"
                        data-repeater-create=""
                        className="btn btn-sm btn-light"
                        onClick={() =>
                          configurationProvider.onAddClick(
                            configurationConstants.AUDITING_CONFIGURATION,
                            configurationConstants.AUDIT_OPTIONS,
                          )
                        }
                      >
                        <span className="svg-icon svg-icon-2">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              opacity="0.5"
                              x="11"
                              y="18"
                              width="12"
                              height="2"
                              rx="1"
                              transform="rotate(-90 11 18)"
                              fill="currentColor"
                            />
                            <rect
                              x="6"
                              y="11"
                              width="12"
                              height="2"
                              rx="1"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        Add another
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="card card-flush mb-4">
              <div className="card-header">
                <div className="card-title">
                  <h4>Feedback Types</h4>
                </div>
              </div>
              <div className="card-body pt-0">
                <div
                  className=""
                  data-kt-ecommerce-catalog-add-product="auto-options"
                >
                  <div id="kt_ecommerce_add_product_options">
                    <div className="form-group">
                      <div
                        data-repeater-list="kt_ecommerce_add_product_options"
                        className="d-flex flex-column gap-3"
                      >
                        {location?.length !== 0
                          ? data.configFeedbackTypes.map((item, i) => (
                              <div
                                data-repeater-item=""
                                className="form-group d-flex flex-wrap align-items-center gap-5"
                                key={i}
                              >
                                <input
                                  type="text"
                                  className="form-control mw-100 w-85"
                                  name="product_option_value"
                                  value={
                                    (configurationProvider.editedData[
                                      configurationConstants
                                        .AUDITING_CONFIGURATION
                                    ][configurationConstants.FEEDBACK_TYPES] ??
                                      {})[item.id] ?? item.feed_type_name
                                  }
                                  placeholder={item.feed_type_name}
                                  onChange={(e) =>
                                    configurationProvider.onEditFieldChange(
                                      configurationConstants.AUDITING_CONFIGURATION,
                                      configurationConstants.FEEDBACK_TYPES,
                                      item.id,
                                      e.target.value,
                                    )
                                  }
                                />
                                <button
                                  type="button"
                                  data-repeater-delete=""
                                  className="btn btn-sm btn-icon btn-light-danger"
                                  onClick={() => {
                                    setDeleteParams({
                                      config_option: item?.feed_type_name,
                                      id: item?.id,
                                      LocationId: item?.LocationId,
                                      clientCurrentId,
                                      type: feedbackTypes,
                                    });
                                    setShowConfirmationModal(true);
                                  }}
                                >
                                  <span className="svg-icon svg-icon-1">
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect
                                        opacity="0.5"
                                        x="7.05025"
                                        y="15.5356"
                                        width="12"
                                        height="2"
                                        rx="1"
                                        transform="rotate(-45 7.05025 15.5356)"
                                        fill="currentColor"
                                      />
                                      <rect
                                        x="8.46447"
                                        y="7.05029"
                                        width="12"
                                        height="2"
                                        rx="1"
                                        transform="rotate(45 8.46447 7.05029)"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                </button>
                              </div>
                            ))
                          : ""}
                      </div>
                      <div className="form-group mt-5">
                        <div className="form-group">
                          <div
                            data-repeater-list="kt_ecommerce_add_product_options"
                            className="d-flex flex-column gap-3"
                          >
                            {(
                              configurationProvider.submitData[
                                configurationConstants.AUDITING_CONFIGURATION
                              ].feedback_types ?? []
                            ).map((item, i) => {
                              return (
                                <div id="kt_ecommerce_add_product_options">
                                  <div id="process">
                                    <div className="applicant-fields">
                                      <div className="form-group">
                                        <div
                                          data-repeater-list="kt_ecommerce_add_product_options"
                                          className="d-flex flex-column gap-3"
                                        >
                                          <div
                                            data-repeater-item=""
                                            className="form-group d-flex flex-wrap align-items-center gap-5"
                                          >
                                            <input
                                              type="text"
                                              className="form-control mw-100 w-85"
                                              value={
                                                (configurationProvider.submitData[
                                                  configurationConstants
                                                    .AUDITING_CONFIGURATION
                                                ][configurationConstants.FEEDBACK_TYPES] ?? {})[
                                                  item.id
                                                ] ?? item
                                              }
                                              onChange={(e) =>
                                                configurationProvider.onFieldChange(
                                                  configurationConstants.AUDITING_CONFIGURATION,
                                                  configurationConstants.FEEDBACK_TYPES,
                                                  i,
                                                  e.target.value,
                                                )
                                              }
                                            />
                                            <button
                                              type="button"
                                              data-repeater-delete=""
                                              className="btn btn-sm btn-icon btn-light-danger"
                                              onClick={() =>
                                                configurationProvider.onDeleteClick(
                                                  configurationConstants.AUDITING_CONFIGURATION,
                                                  configurationConstants.FEEDBACK_TYPES,
                                                  i,
                                                )
                                              }
                                            >
                                              <span className="svg-icon svg-icon-1">
                                                <svg
                                                  width="24"
                                                  height="24"
                                                  viewBox="0 0 24 24"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <rect
                                                    opacity="0.5"
                                                    x="7.05025"
                                                    y="15.5356"
                                                    width="12"
                                                    height="2"
                                                    rx="1"
                                                    transform="rotate(-45 7.05025 15.5356)"
                                                    fill="currentColor"
                                                  />
                                                  <rect
                                                    x="8.46447"
                                                    y="7.05029"
                                                    width="12"
                                                    height="2"
                                                    rx="1"
                                                    transform="rotate(45 8.46447 7.05029)"
                                                    fill="currentColor"
                                                  />
                                                </svg>
                                              </span>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group mt-5">
                      <button
                        type="button"
                        data-repeater-create=""
                        className="btn btn-sm btn-light"
                        onClick={() =>
                          configurationProvider.onAddClick(
                            configurationConstants.AUDITING_CONFIGURATION,
                            configurationConstants.FEEDBACK_TYPES,
                          )
                        }
                      >
                        <span className="svg-icon svg-icon-2">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              opacity="0.5"
                              x="11"
                              y="18"
                              width="12"
                              height="2"
                              rx="1"
                              transform="rotate(-90 11 18)"
                              fill="currentColor"
                            />
                            <rect
                              x="6"
                              y="11"
                              width="12"
                              height="2"
                              rx="1"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        Add another
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showConfirmationModal && (
        <ConfirmationModal
          deleteParams={deleteParams}
          setDeleteParams={setDeleteParams}
          showConfirmationModal={showConfirmationModal}
          setShowConfirmationModal={setShowConfirmationModal}
          fetchConfigurationData={fetchConfigurationData}
        />
      )}
    </>
  );
};
export default AuditingConfiguration;
